import { useState, useRef, useMemo } from 'react';
import jwtToken from '@utils/jwtToken';
import { parseHtml } from './PostContent/util';
import { getInnerText } from '@utils/sundries';
import useClient from '@lib/hooks/useClient';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect';
import { getClient } from '@api/feedStream';
import { NEWS_PATHS } from '@constants/index';
import I18n from '@utils/i18n';

export const useNewsPaging = ({
  defaultList = [],
  nextId = '',
  defaultStatus = 'success',
  fetchFn,
  fetchParams = {},
  needToken
}) => {
  const [list, setList] = useState(defaultList);
  const listRef = useRef(defaultList);
  const pageId = useRef(nextId);
  const [status, setStatus] = useState(defaultStatus);
  const [isRefresh, setIsRefresh] = useState(false);

  const fetchData = async (unObserver) => {
    setStatus('loading');
    if (!unObserver) {
      // !unObserver true 则是刷新请求第一页
      // isRefresh用来区分是加载更多还是刷新
      setIsRefresh(true);
    } else {
      setIsRefresh(false);
    }

    const data = await fetchFn(
      {
        ...fetchParams,
        id_lte: unObserver ? pageId.current : ''
      },
      needToken ? { Authorization: jwtToken.getToken() } : {}
    );

    setStatus('success');
    const list = [...listRef.current, ...data?.result];
    pageId.current = data?.nextId;

    if (!unObserver) {
      // !unObserver true 则是刷新请求第一页
      listRef.current = data.result;
      setList(data?.result);
    }
    if (unObserver) {
      !data?.result?.length && unObserver();
      setList(list);
      listRef.current = list;
    }
  };

  return {
    list,
    status,
    fetchData,
    isRefresh
  };
};

export function useTimeLingContext ({
  title,
  summary,
  id,
  nickName,
  shareCount
}) {
  const [curShareCount, setCurShareCount] = useState(shareCount);
  const [richText, setRichText] = useState('');
  const [initText, setInitText] = useState('');
  const [shareLink, setShareLink] = useState('');
  const [showMore, setShowMore] = useState(false);
  const [isRequired, setIsRequired] = useState(false);
  const isPC = useClient();
  const defaultRichText = parseHtml(summary).htmlText;
  const contentRef = useRef();
  const containerRef = useRef();

  useIsomorphicLayoutEffect(() => {
    setInitText(getInnerText(summary));
  }, []);

  const shareTitle = useMemo(() => {
    return `${nickName} say:${title || '...'}`;
  }, [nickName, title]);
  useIsomorphicLayoutEffect(() => {
    setCurShareCount(shareCount);
  }, [shareCount]);
  useIsomorphicLayoutEffect(() => {
    setShareLink(
      `${window?.location.origin}/${I18n.locale}${NEWS_PATHS.POST}/${id}`
    );
  }, [id]);
  const showHeight = useMemo(() => {
    return isPC ? 48 : 52;
  }, [isPC]);

  const needRequired = useMemo(() => {
    if (summary.length > 300) {
      if (initText === 300) {
        // 新资讯逻辑
        return true;
      }
    }
    if (summary.length === 300) {
      // 老资讯逻辑
      return true;
    }
    return false;
  }, [summary]);

  const openContent = (hash) => {
    if (needRequired && !isRequired) {
      getClient()
        .feed('post', 'square')
        .get({
          id_lte: id,
          id_gte: id
        })
        .then((data) => {
          setIsRequired(true);
          setRichText(
            parseHtml(data?.result?.text).htmlText || defaultRichText
          );
          setShowMore(true);
        });
    }
    if (showMore && containerRef.current.clientHeight > window?.innerHeight) {
      location.hash = hash;
    }
    if (!showMore) {
      history.replaceState(null, null, ' ');
    }
    setShowMore(!showMore);
  };
  return {
    defaultRichText,
    shareCount,
    showMore,
    richText,
    needRequired,
    shareTitle,
    curShareCount,
    setCurShareCount,
    openContent,
    contentRef,
    showHeight,
    containerRef,
    shareLink
  };
}
